import cn from "classnames"
import React from "react"

import styles from "./index.module.css"

type Props = {
  className?: string
  classNameWrapper?: string
  maxSize: "md" | "sm" | "xs"
}

export const ScrollSnap: React.FC<Props> = ({ children, classNameWrapper, className, maxSize }) => {
  const extendedChildren = React.Children.map(children as React.ReactElement, (child) =>
    React.cloneElement(child, {
      className: cn(child.props.className, {
        [styles.XsCard]: maxSize === "xs",
        [styles.SmCard]: maxSize === "sm",
        [styles.MdCard]: maxSize === "md",
      }),
    }),
  )

  return (
    <div
      className={cn(classNameWrapper, {
        [styles.XsWrapper]: maxSize === "xs",
        [styles.SmWrapper]: maxSize === "sm",
        [styles.MdWrapper]: maxSize === "md",
      })}
    >
      <div
        className={cn(className, {
          [styles.XsInner]: maxSize === "xs",
          [styles.SmInner]: maxSize === "sm",
          [styles.MdInner]: maxSize === "md",
        })}
      >
        {extendedChildren}
      </div>
    </div>
  )
}
